import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  drawerPaper: {
    width: 980,
    [theme.breakpoints.down(1024)]: {
      width: '80%'
    }
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    padding: theme.spacing(2)
  },
  uploads: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  }
}));
